const activeLocks = new Set();

let scrollLockState = null;

const applyScrollLock = () => {
  if (scrollLockState || typeof window === 'undefined') {
    return;
  }

  const { body, documentElement } = document;
  const scrollY = window.scrollY;

  scrollLockState = {
    scrollY,
    bodyOverflow: body.style.overflow,
    bodyPosition: body.style.position,
    bodyTop: body.style.top,
    bodyLeft: body.style.left,
    bodyRight: body.style.right,
    bodyWidth: body.style.width,
    bodyOverscrollBehavior: body.style.overscrollBehavior,
    htmlOverflow: documentElement.style.overflow,
    htmlOverscrollBehavior: documentElement.style.overscrollBehavior,
  };

  documentElement.style.overflow = 'hidden';
  documentElement.style.overscrollBehavior = 'none';

  body.style.overflow = 'hidden';
  body.style.position = 'fixed';
  body.style.top = `-${scrollY}px`;
  body.style.left = '0';
  body.style.right = '0';
  body.style.width = '100%';
  body.style.overscrollBehavior = 'none';
};

const releaseScrollLock = () => {
  if (!scrollLockState || typeof window === 'undefined') {
    return;
  }

  const { body, documentElement } = document;

  documentElement.style.overflow = scrollLockState.htmlOverflow;
  documentElement.style.overscrollBehavior = scrollLockState.htmlOverscrollBehavior;

  body.style.overflow = scrollLockState.bodyOverflow;
  body.style.position = scrollLockState.bodyPosition;
  body.style.top = scrollLockState.bodyTop;
  body.style.left = scrollLockState.bodyLeft;
  body.style.right = scrollLockState.bodyRight;
  body.style.width = scrollLockState.bodyWidth;
  body.style.overscrollBehavior = scrollLockState.bodyOverscrollBehavior;

  window.scrollTo(0, scrollLockState.scrollY);
  scrollLockState = null;
};

const lockBodyScroll = (condition, source = 'default') => {
  if (typeof document === 'undefined') {
    return;
  }

  if (condition) {
    activeLocks.add(source);
    applyScrollLock();
    return;
  }

  activeLocks.delete(source);

  if (!activeLocks.size) {
    releaseScrollLock();
  }
};

export const clearBodyScrollLocks = () => {
  activeLocks.clear();
  releaseScrollLock();
};

export default lockBodyScroll;
